import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/render/project/src/node_modules/.pnpm/gatsby-theme-docz@2.3.1_@babel+core@7.11.1_@types+node@24.7.0_docz@2.4.0_@babel+core@7._04842b0c5656885ffb9b2f355e30df2b/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "gadget-requirements"
    }}>{`Gadget Requirements`}</h1>
    <blockquote>
      <p parentName="blockquote">{`When adding a gadget, you should consider all of the following items.`}</p>
    </blockquote>
    <ul {...{
      "className": "contains-task-list"
    }}>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Config Mode (UI)`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Edit Mode (UI)`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`View Mode (UI)`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Mobile Support (UI)`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Accessibility (UI)`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Conditional Visibility (UI,API,Forms)`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Clientside Validation (UI)`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Serverside Validation (Forms)`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Document List View (UI)`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Document List Filter (UI)`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Document List Sort (UI)`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`CSV Download Support (API)`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Export to PDF Support (PDF)`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Anonymous Forms Support (UI)`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Workflow Simulator Support (UI)`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Workflow Notification Support (UI,Workflows)`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Workflow Conditional Logic Support (UI,Workflows)`}</li>
    </ul>
    <h1 {...{
      "id": "creating-a-new-gadget"
    }}>{`Creating a New Gadget`}</h1>
    <p>{`When creating a new gadget, there are a few main places to pay attention to:`}</p>
    <h2 {...{
      "id": "modern-best-practices-2025"
    }}>{`Modern Best Practices (2025)`}</h2>
    <h3 {...{
      "id": "react-component-patterns"
    }}>{`React Component Patterns`}</h3>
    <p><strong parentName="p">{`Use Functional Components`}</strong></p>
    <p>{`New gadgets should use functional components with hooks, not class components:`}</p>
    <ul>
      <li parentName="ul">{`Use `}<inlineCode parentName="li">{`useState`}</inlineCode>{` for local state management`}</li>
      <li parentName="ul">{`Use `}<inlineCode parentName="li">{`useRef`}</inlineCode>{` for tracking previous values and DOM references`}</li>
      <li parentName="ul">{`Avoid `}<inlineCode parentName="li">{`useEffect`}</inlineCode>{` unless absolutely necessary (external system sync only)`}</li>
      <li parentName="ul">{`Example: `}<inlineCode parentName="li">{`app/src/formbot/gadgets/phone-number/edit.jsx`}</inlineCode></li>
    </ul>
    <p><strong parentName="p">{`Avoid Unnecessary Debouncing`}</strong></p>
    <p>{`Only debounce if you have a specific performance reason. Most gadgets don't need it. Immediate feedback is better for user experience.`}</p>
    <h3 {...{
      "id": "styling"
    }}>{`Styling`}</h3>
    <p><strong parentName="p">{`Use Tailwind CSS`}</strong></p>
    <p>{`All new gadgets should use Tailwind utility classes:`}</p>
    <ul>
      <li parentName="ul">{`Example: `}<inlineCode parentName="li">{`className='w-full border-none bg-none px-4 pb-4 outline-none'`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "accessibility-requirements"
    }}>{`Accessibility Requirements`}</h3>
    <p>{`All gadgets must include proper accessibility features:`}</p>
    <p><strong parentName="p">{`ARIA Attributes`}</strong></p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`aria-labelledby`}</inlineCode>{` - References the field label`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`aria-describedby`}</inlineCode>{` - References all descriptive content (help text, format hints, error messages). Use space-separated IDs for multiple descriptions (e.g., `}<inlineCode parentName="li">{`aria-describedby="field-help field-error"`}</inlineCode>{`)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`aria-required`}</inlineCode>{` - Indicates required fields`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`aria-invalid`}</inlineCode>{` - Set to `}<inlineCode parentName="li">{`"true"`}</inlineCode>{` when validation errors exist`}</li>
    </ul>
    <p><strong parentName="p">{`Error Announcements`}</strong></p>
    <p>{`Error messages must have `}<inlineCode parentName="p">{`role="alert"`}</inlineCode>{` and an ID referenced in `}<inlineCode parentName="p">{`aria-describedby`}</inlineCode>{` so screen readers can announce them properly.`}</p>
    <p><strong parentName="p">{`Semantic HTML`}</strong></p>
    <p>{`Use appropriate input types for better mobile keyboard support:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`type='tel'`}</inlineCode>{` for phone numbers`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`type='email'`}</inlineCode>{` for email addresses`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`type='number'`}</inlineCode>{` for numeric input (when appropriate)`}</li>
    </ul>
    <p><strong parentName="p">{`Keyboard Support`}</strong></p>
    <p>{`Standard keyboard navigation must work without requiring a mouse.`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`: See PhoneNumber gadget's ARIA implementation in `}<inlineCode parentName="p">{`app/src/formbot/gadgets/phone-number/edit.jsx`}</inlineCode></p>
    <h2 {...{
      "id": "code-organization"
    }}>{`Code Organization`}</h2>
    <h3 {...{
      "id": "file-structure"
    }}>{`File Structure`}</h3>
    <pre><code parentName="pre" {...{}}>{`app/src/formbot/gadgets/your-gadget/
├── edit.jsx          # UI and user interaction
├── view.jsx          # Display logic
├── config.jsx        # Configuration UI
├── utils.js          # Business logic (formatting, parsing, calculations)
├── validation.jsx    # Validation rules
├── progressive-disclosure.jsx
├── icon.svg.jsx      # Gadget icon
└── manifest.jsx      # Ties everything together
`}</code></pre>
    <h3 {...{
      "id": "separation-of-concerns"
    }}>{`Separation of Concerns`}</h3>
    <p>{`Abstract business logic into utility files - this pattern is used by Currency, Checkboxes, Table, and other gadgets:`}</p>
    <p><strong parentName="p">{`Why utils.js?`}</strong></p>
    <ul>
      <li parentName="ul">{`Keeps components focused on UI`}</li>
      <li parentName="ul">{`Makes business logic testable in isolation`}</li>
      <li parentName="ul">{`Pure functions are easier to reason about`}</li>
      <li parentName="ul">{`Examples: `}<inlineCode parentName="li">{`currency/utils.js`}</inlineCode>{`, `}<inlineCode parentName="li">{`checkboxes/utils.jsx`}</inlineCode>{`, `}<inlineCode parentName="li">{`table/utils.jsx`}</inlineCode>{`, `}<inlineCode parentName="li">{`phone-number/utils.js`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "pure-functions-in-utils"
    }}>{`Pure Functions in Utils`}</h3>
    <p>{`Utility functions should be:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Side-effect free`}</strong>{` - No external state modification`}</li>
      <li parentName="ul"><strong parentName="li">{`Deterministic`}</strong>{` - Same input always produces same output`}</li>
      <li parentName="ul"><strong parentName="li">{`Testable`}</strong>{` - Easy to unit test in isolation`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// Good: Pure function
export const formatPhoneNumber = (digits, country) => {
  // formatting logic
  return formattedNumber
}

// Bad: Side effects
export const formatPhoneNumber = (digits, country) => {
  setGlobalState(digits) // ❌ Side effect
  return formattedNumber
}
`}</code></pre>
    <h2 {...{
      "id": "testing"
    }}>{`Testing`}</h2>
    <h3 {...{
      "id": "comprehensive-coverage-required"
    }}>{`Comprehensive Coverage Required`}</h3>
    <p>{`All gadgets should have thorough test coverage:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Component tests`}</strong>{` - User interactions, rendering, props changes`}</li>
      <li parentName="ul"><strong parentName="li">{`Utility function tests`}</strong>{` - All pure functions in utils.js`}</li>
      <li parentName="ul"><strong parentName="li">{`Edge cases`}</strong>{` - Empty values, null, undefined, max length, special characters`}</li>
      <li parentName="ul"><strong parentName="li">{`Accessibility tests`}</strong>{` - External value sync, ARIA attributes, error states`}</li>
    </ul>
    <p><strong parentName="p">{`Aim for 15-20+ tests for complex gadgets.`}</strong></p>
    <p>{`Example: PhoneNumber gadget has 19+ comprehensive tests covering formatting, deletion, digit limits, and accessibility.`}</p>
    <p>{`Test files location:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`app/src/formbot/gadgets/your-gadget/__tests__/edit.test.jsx`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`app/src/formbot/gadgets/your-gadget/__tests__/utils.test.jsx`}</inlineCode></li>
    </ul>
    <h2 {...{
      "id": "using-third-party-libraries"
    }}>{`Using Third-Party Libraries`}</h2>
    <p>{`When gadget functionality requires complex logic (phone formatting, date handling, etc.), prefer industry-standard libraries over custom implementations.`}</p>
    <h3 {...{
      "id": "license-requirements-️"
    }}>{`License Requirements ⚠️`}</h3>
    <p><strong parentName="p">{`ONLY use libraries with permissive licenses:`}</strong></p>
    <ul>
      <li parentName="ul">{`✅ `}<strong parentName="li">{`Approved`}</strong>{`: MIT, BSD, Apache 2.0, ISC`}</li>
      <li parentName="ul">{`❌ `}<strong parentName="li">{`Prohibited`}</strong>{`: GPL, AGPL, LGPL, proprietary licenses, or any license that:`}
        <ul parentName="li">
          <li parentName="ul">{`Requires disclosure of source code`}</li>
          <li parentName="ul">{`Requires payment or royalties`}</li>
          <li parentName="ul">{`Requires releasing derivative works under the same license`}</li>
          <li parentName="ul">{`Has copyleft provisions`}</li>
        </ul>
      </li>
    </ul>
    <p><strong parentName="p">{`Before adding a dependency`}</strong>{`, check `}<inlineCode parentName="p">{`node_modules/[package]/package.json`}</inlineCode>{` for the `}<inlineCode parentName="p">{`"license"`}</inlineCode>{` field.`}</p>
    <h3 {...{
      "id": "recommended-libraries"
    }}>{`Recommended Libraries`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Phone formatting`}</strong>{`: `}<inlineCode parentName="li">{`libphonenumber-js`}</inlineCode>{` (MIT)`}</li>
      <li parentName="ul"><strong parentName="li">{`Date handling`}</strong>{`: `}<inlineCode parentName="li">{`date-fns`}</inlineCode>{` (MIT)`}</li>
      <li parentName="ul"><strong parentName="li">{`Utilities`}</strong>{`: `}<inlineCode parentName="li">{`lodash`}</inlineCode>{` (MIT)`}</li>
    </ul>
    <p>{`Document library choices and their purposes in code comments.`}</p>
    <h2 {...{
      "id": "example-gadgets"
    }}>{`Example Gadgets`}</h2>
    <p>{`When getting started, reference these gadgets:`}</p>
    <p><strong parentName="p">{`For basic structure:`}</strong></p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Text gadget`}</strong>{` (`}<inlineCode parentName="li">{`app/src/formbot/gadgets/text/`}</inlineCode>{`) - Simple text input, shows file organization`}</li>
    </ul>
    <p><strong parentName="p">{`For modern implementation patterns:`}</strong></p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`PhoneNumber gadget`}</strong>{` (`}<inlineCode parentName="li">{`app/src/formbot/gadgets/phone-number/`}</inlineCode>{`) - Demonstrates 2025 best practices:`}
        <ul parentName="li">
          <li parentName="ul">{`Functional components with hooks`}</li>
          <li parentName="ul">{`Tailwind CSS styling`}</li>
          <li parentName="ul">{`Proper ARIA accessibility`}</li>
          <li parentName="ul">{`Business logic in utils.js`}</li>
          <li parentName="ul">{`Comprehensive test coverage (19+ tests)`}</li>
        </ul>
      </li>
    </ul>
    <p><strong parentName="p">{`For complex features:`}</strong></p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Currency gadget`}</strong>{` (`}<inlineCode parentName="li">{`app/src/formbot/gadgets/currency/`}</inlineCode>{`) - Complex formatting and calculations`}</li>
      <li parentName="ul"><strong parentName="li">{`Table gadget`}</strong>{` (`}<inlineCode parentName="li">{`app/src/formbot/gadgets/table/`}</inlineCode>{`) - Advanced data structures`}</li>
      <li parentName="ul"><strong parentName="li">{`Repeater gadget`}</strong>{` (`}<inlineCode parentName="li">{`app/src/formbot/gadgets/repeater/`}</inlineCode>{`) - Dynamic nested content`}</li>
    </ul>
    <h2 {...{
      "id": "builder-ui"
    }}>{`builder-ui`}</h2>
    <p>{`Gadgets live in `}<inlineCode parentName="p">{`app/src/formbot/gadgets`}</inlineCode>{`. The manifest file ties everything together, and gadgets are registered in `}<inlineCode parentName="p">{`app/src/formbot/index.jsx`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "builder-api-node"
    }}>{`builder-api-node`}</h2>
    <p>{`Gadgets are defined in `}<inlineCode parentName="p">{`server/gadgets`}</inlineCode>{` and exported from `}<inlineCode parentName="p">{`server/gadgets/index.js`}</inlineCode>{`. The main configuration options
are as follows:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`defaultValue`}</inlineCode>{`: Pretty straightforward - a good place to put a sane default.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`progressiveDisclosure`}</inlineCode>{`: Defines the rules specific to this gadget for progressive disclosure.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`validateShape`}</inlineCode>{`: Defines the required structure of the value.`}</li>
    </ul>
    <h2 {...{
      "id": "forms-api"
    }}>{`forms-api`}</h2>
    <p>{`Gadgets live in `}<inlineCode parentName="p">{`server/lib/gadgets`}</inlineCode>{` and exported from `}<inlineCode parentName="p">{`server/lib/gadgets/index.js`}</inlineCode>{`. There is unfortunately a lot
of repetition in the gadget definition defined here and in `}<inlineCode parentName="p">{`builder-api-node`}</inlineCode>{`. One big difference is that gadgets
defined here accept a `}<inlineCode parentName="p">{`validations`}</inlineCode>{` key for server-side validations. However, be forewarned that server-side validation
error messages do not currently get rendered by the client app.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      